import { Skeleton } from '@shared/components/shadcn';
import type { ComponentProps } from 'react';
import { BIG_WINNER_POD_CONTAINER_CLASS } from './constants';

type BigWinnerPodSkeletonProps = ComponentProps<typeof Skeleton>;

function BigWinnerPodSkeleton({ className, ...props }: BigWinnerPodSkeletonProps) {
  return <Skeleton className={className ?? BIG_WINNER_POD_CONTAINER_CLASS} {...props} />;
}

export { BigWinnerPodSkeleton };
